<mat-toolbar class="navbar">
  @if (isUserLoggedIn) {
    <button
      mat-icon-button
      class="menu-button"
      (click)="toggleSidenav()"
      >
      <mat-icon>menu</mat-icon>
    </button>
  }

  <a routerLink="/home">
    <img src="../../../assets/images/Logo.png" class="logo ml-4" />
  </a>

  <span class="example-spacer"></span>

  <!-- <a href="https://healthpossibleinc.org/" class="link-styling">HOME</a>
  <a href="https://healthpossibleinc.org/join-now/" class="link-styling">JOIN NOW</a>
  <a href="https://healthpossibleinc.org/whoweare/" class="link-styling">WHO WE ARE</a>
  <a href="https://healthpossibleinc.org/about/" class="link-styling">OUR TEAM</a>
  <a href="https://healthpossibleinc.org/contact/" class="link-styling">CONTACT</a>
  <a href="https://healthpossibleinc.org/donate-2/" class="link-styling">DONATE</a> -->
</mat-toolbar>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav [mode]="isMobile() ? 'over' : 'side'" [opened]="showSidenav">
    <mat-nav-list>
      @if (getLoggedInUserRole == 'Admin') {
        @for (route of adminRoutes | keyvalue; track route.key) {
        <a
          mat-list-item
          routerLink="{{ route.key }}"
          routerLinkActive="mdc-list-item--activated"
          [routerLinkActiveOptions]="{ exact: true }"
          class="border-2"
          style="border-radius: 0px;"
        >
          <div class="list-item-text whitespace-normal">
            {{ route.value }}
          </div>
        </a>
        }
      }

      @if (getLoggedInUserRole == 'Associate') {
        @for (route of routes | keyvalue; track route.key) {
          <a
            mat-list-item
            routerLink="{{ route.key }}"
            routerLinkActive="mdc-list-item--activated"
            [routerLinkActiveOptions]="{ exact: true }"
            style="border-radius: 0px;"
            >
          <div class="list-item-text whitespace-normal">
            {{ route.value }}
          </div>
          </a>
        }
      }
    </mat-nav-list>

    <button mat-button class="logout-button border-2" (click)="logout()">
      Logout
    </button>
  </mat-sidenav>

  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
